import React, { useCallback, useEffect, useMemo, useRef } from "react";
import PortfolioMobileContent from "./PortfolioMobileContent";
import { PORTFOLIO_TABS } from "../constants/portfolioConstants";

export default function PortfolioMobileUI({
  dashboard,
  category,
  tabActive,
  onSelectTab,
  onBack,
  introduceModel,
  buildListModel,
}) {
  // Header 탭 상태와 Swiper index를 양방향 동기화하기 위한 ref/state.
  const mobileSwiperRef = useRef(null);
  const activeTabIndex = useMemo(() => {
    const index = PORTFOLIO_TABS.findIndex((tab) => tab.key === tabActive);
    return index >= 0 ? index : 0;
  }, [tabActive]);

  // 스와이프 완료 시 활성 탭 키를 상위 상태로 반영한다.
  const handleMobileSlideChange = useCallback((swiper) => {
    const nextKey = PORTFOLIO_TABS[swiper.activeIndex]?.key;
    if (nextKey && nextKey !== tabActive) {
      onSelectTab(nextKey);
    }
  }, [onSelectTab, tabActive]);

  const handleMobileSwiperInit = useCallback((swiper) => {
    mobileSwiperRef.current = swiper;
    requestAnimationFrame(() => {
      swiper.update();
    });
  }, []);

  // 상위에서 탭이 바뀐 경우 Swiper도 같은 index로 이동시킨다.
  useEffect(() => {
    const swiper = mobileSwiperRef.current;
    if (!swiper) return;
    if (swiper.activeIndex !== activeTabIndex) {
      swiper.slideTo(activeTabIndex);
    }
  }, [activeTabIndex]);

  // 모바일 패널 표시/데이터 변경 후에도 Swiper 크기를 최신 상태로 맞춘다.
  useEffect(() => {
    const swiper = mobileSwiperRef.current;
    if (!swiper) return;
    requestAnimationFrame(() => {
      swiper.update();
    });
  }, [dashboard, activeTabIndex]);

  return (
    <PortfolioMobileContent
      dashboard={dashboard}
      category={category}
      tabActive={tabActive}
      onSelectTab={onSelectTab}
      onBack={onBack}
      activeTabIndex={activeTabIndex}
      introduceModel={introduceModel}
      buildListModel={buildListModel}
      onSwiper={handleMobileSwiperInit}
      onSlideChange={handleMobileSlideChange}
    />
  );
}
